/**
 * Google Map Javascript
 * Raj Janorkar
 */

function initAutocomplete () {
    let componentForm = {
        street_number: 'short_name',
        // route: 'long_name',
        locality: 'long_name', // Pinjar, pinjar
        administrative_area_level_2: 'short_name', // Akola, akola
        administrative_area_level_1: 'long_name', // Maharashtra
        country: 'long_name', // India
        postal_code: 'short_name' // 444405
    };

    const options = {
        types: ['(cities)'],
        fields: ["place_id"],
        // componentRestrictions: {country: "au"}
    };

    // Create the autocomplete object, restricting the search
    // to geographical location types.
    const input = document.getElementsByClassName('google-address');

    for (let i = 0; i < input.length; i++) {
        const places = new google.maps.places.Autocomplete(input[i], options);
        places.inputId = $(input[i]).parent().attr('id');

        places.addListener('place_changed', () => {
            const lastAddress = $('#' + places.inputId);
            // initialize all the fields val to blank
            for (const component in componentForm) {
                lastAddress.find('#' + component).val('');
            }
            const results = places.getPlace();

            if (results && results.place_id) {
                const placesService = new google.maps.places.PlacesService(document.createElement('div')); // Create a dummy div
                // Avoid paying for data that you don't need by restricting the set of
                // place fields that are returned to just the address components.
                placesService.getDetails({
                    placeId: results.place_id,
                    fields: ["address_components"],
                }, (place, status) => {
                    if (status === "OK" && place && place.address_components) {
                        const address_components = place.address_components;
                        for (const component of address_components) {
                            for (const type of component.types) {
                                if (componentForm[type]) {
                                    const val = component[componentForm[type]];
                                    lastAddress.find('#' + type).val(val);
                                }
                            }
                        }
                    }
                });
            }
        });
    }
}

// export this module to make it available to others
export { initAutocomplete };
